/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'querystring';
import moment from 'moment';
import history from '../../../history';

import PayrollTable from './PayrollTable';
import PayrollFilters from './PayrollFilters';

import { fetchPayroll } from '../../../actions/Payroll';
import {
    withPushFiltersToUrl,
    withRefreshTableOnFilterChange,
} from '../../operations/common/decorators';

@withPushFiltersToUrl
@withRefreshTableOnFilterChange
class Payroll extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bookings_after: moment()
                .startOf('isoWeek')
                .startOf('day')
                .subtract(1, 'week')
                .toISOString(),
            bookings_before: moment()
                .endOf('isoWeek')
                .endOf('day')
                .subtract(1, 'week')
                .toISOString(),
        };
    }

    componentDidMount() {
        const { search, query } = this.props.location;
        const currentUrlParams = new URLSearchParams(history.location.search);
        if (history.location.search) {
            if (currentUrlParams.has('bookings_client')) {
                currentUrlParams.delete('bookings_client');
                history.push({
                    pathname: '/payments/payroll/',
                    search: currentUrlParams.toString(),
                });
                return;
            }
            this.props.load(currentUrlParams);
        } else {
            const paramString = qs.stringify(this.state);
            history.push({
                pathname: '/payments/payroll/',
                search: paramString,
            });
        }
    }

    componentWillReceiveProps(nextprops) {
        if (this.props.location.search !== nextprops.location.search) {
            history.push({
                pathname: this.props.location.pathname,
                search: nextprops.location.search
                    ? nextprops.location.search
                    : qs.stringify(this.state),
            });
        }
    }

    onFilterChange = (id, content) => {
        this.props.onFilterChange(id, content);
    };

    onRowExpand = id => {
        history.push({
            pathname: `/payments/payroll/expanded/${id}/`,
            search: this.props.location.search,
        });
    };

    onRowCollapse = id => {
        const pathname = this.props.location.pathname.replace(
            `/expanded/${id}`,
            '',
        );
        history.push({
            pathname,
            search: this.props.location.search,
        });
    };

    findRowIndex = id => {
        if (this.props.match.params.method == 'expanded')
            return this.props.content.findIndex(worker => worker.id == id);
    };

    setRef = el => {
        this.subComponent = el;
    };

    refreshTable = () => {
        const currentUrlParams = new URLSearchParams(history.location.search);
        this.props.load(currentUrlParams);
        this.subComponent ? this.subComponent.reloadSubData() : null;
    };

    render() {
        return (
            <div className="table-container">
                <PayrollFilters
                    onFilterChange={this.onFilterChange}
                    history={history}
                    reloadData={this.refreshTable}
                    notification={this.props.notification}
                />
                <PayrollTable
                    expanded={this.findRowIndex(this.props.match.params.id)}
                    match={this.props.match}
                    onRowExpand={this.onRowExpand}
                    onRowCollapse={this.onRowCollapse}
                    loading={this.props.fetching}
                    content={this.props.content}
                    meta={this.props.meta}
                    notification={this.props.notification}
                    ref={table => (
                        (this.table = table), this.props.setTable(table)
                    )}
                    table={this.table}
                    reloadData={this.refreshTable}
                    onSortedChange={this.props.onSortedChange}
                    onPageChange={this.props.onPageChange}
                    page={this.props.currentPage}
                    errorMsg={this.props.error}
                    history={history}
                    setRef={this.setRef}
                    subComponent={this.subComponent}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    ...state.payroll,
    user: state.user,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    load: searchParams => dispatch(fetchPayroll(searchParams)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payroll);
